import React, { useState, useMemo } from "react";
import DriverComponent from "./DriverComponent";
import { DRIVER_QUERY } from "../queries";
import { useClientQueryWithSimpleErrorHandling } from "hooks";
import { get, set } from "@totalsoft/change-tracking-react";
import PropTypes from "prop-types";
import { shape, required, fromModel, stopOnFirstFailure } from "@totalsoft/pure-validations";
import { isCnp } from "utils/simple-validations/validations";
import { useDirtyFieldValidation } from "@totalsoft/pure-validations-react";

const uniqueIdValidator = () => {
  return fromModel(_ =>
    shape({
      uniqueID: [required, isCnp] |> stopOnFirstFailure
    })
  );
};

const DriverContainer = ({ driver, defaultCountryCode, index, onDeleteDriver, validation, readOnly }) => {
  const validatorUniqueId = useMemo(() => uniqueIdValidator(), []);
  const [, validateUniqueId] = useDirtyFieldValidation(validatorUniqueId);

  const [expanded, setExpanded] = useState(driver.isExpanded |> get ? true : false);
  const agreesWithPersonalDataUse = driver.agreesWithPersonalDataUse |> get;
  const handlePanelChange = isExpanded => {
    setExpanded(isExpanded);
  };
  const clientQuery = useClientQueryWithSimpleErrorHandling();
  const handleUniqueIDChange = async uniqueID => {
    (driver.uniqueID |> set)(uniqueID);
    if (!validateUniqueId({ uniqueID })) {
      return;
    }

    const { data } = await clientQuery(DRIVER_QUERY, {
      variables: { uniqueID: uniqueID },
      fetchPolicy: "network-only"
    });

    if (data && data.driver)
      (driver |> set)({
        ...data.driver,
        phoneCountryCode: data.driver.phoneCountryCode ?? defaultCountryCode,
        uniqueID,
        id: null,
        agreesWithPersonalDataUse: agreesWithPersonalDataUse
      });
  };

  return (
    <DriverComponent
      onUniqueIDChange={handleUniqueIDChange}
      onPanelChange={handlePanelChange}
      onDeleteDriver={onDeleteDriver}
      expanded={expanded}
      driver={driver}
      defaultCountryCode={defaultCountryCode}
      index={index}
      validation={validation}
      readOnly={readOnly}
    />
  );
};

DriverContainer.propTypes = {
  driver: PropTypes.object.isRequired,
  defaultCountryCode: PropTypes.string,
  index: PropTypes.number.isRequired,
  onDeleteDriver: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired,
  readOnly: PropTypes.func.isRequired
};

export default DriverContainer;
